import { Search as SearchFilters } from "@outschool/business-rules";
import { SearchFilters as SearchFiltersType } from "@outschool/gql-backend-generated";
import { useTranslation } from "@outschool/localization";
import { useSearchFiltersString } from "@outschool/ui-components-website";

import * as Activity from "../../../../shared/Activity";

// Utility for manipulating a "filters" object

export function ageFiltersToArray(filters: SearchFiltersType) {
  if (filters.age) {
    const agesArray = filters.age
      .split(",")
      .map(Number)
      .filter(age => age <= Activity.ageMax);
    return agesArray;
  } else {
    return [];
  }
}

export default function useFilterFormatString() {
  const { t } = useTranslation(
    "client\\components\\search\\mobile\\FilterFormat"
  );
  const { dowSummary, dateFiltersToString: _dateFiltersToString } =
    useSearchFiltersString();
  const topicFiltersToString = (filters: SearchFiltersType) =>
    filters.q ? filters.q : t("All classes");

  const dowFiltersToString = (filters: SearchFiltersType) =>
    dowSummary(filters.dow, false);

  const dateFiltersToString = (filters: SearchFiltersType) => {
    let dateString = _dateFiltersToString(filters);
    if (["All Upcoming Dates", ""].includes(dateString)) {
      return t("All upcoming");
    } else {
      return dateString;
    }
  };

  const timeFiltersToString = (filters: SearchFiltersType) => {
    const startTime =
      filters.startAfterTime &&
      SearchFilters.displayTimeFromCardinalHour(filters.startAfterTime);
    const endTime =
      filters.endByTime &&
      SearchFilters.displayTimeFromCardinalHour(filters.endByTime);
    const timeString =
      startTime && endTime
        ? t("{{startTime}} - {{endTime}}", { startTime, endTime })
        : startTime
        ? t("After {{startTime}}", { startTime })
        : endTime
        ? t("Before {{endTime}}", { endTime })
        : t("Any time");
    return timeString;
  };

  const ageFiltersToString = (filters: SearchFiltersType) => {
    if (filters.age) {
      const agesArray = ageFiltersToArray(filters);
      const agesString = SearchFilters.agesArrayToString(
        agesArray.map(a => a.toString())
      );
      return t("Age {{ages}}", {
        ages: agesString,
        count: agesArray.length,
        defaultValue_plural: "Ages {{ages}}"
      });
    } else {
      return t("All ages");
    }
  };

  const allTemporalFiltersToString = (filters: SearchFiltersType) => {
    return [
      dateFiltersToString(filters),
      dowFiltersToString(filters),
      timeFiltersToString(filters)
    ]
      .filter(Boolean)
      .join(" • ");
  };

  return {
    ageFiltersToString,
    allTemporalFiltersToString,
    allFiltersToString(filters: SearchFiltersType) {
      return [
        topicFiltersToString(filters),
        allTemporalFiltersToString(filters),
        ageFiltersToString(filters)
      ]
        .filter(Boolean)
        .join(" / ");
    }
  };
}
